// Function to return the initial options
import { ActivityComparisonOptions } from "./activity-comparison/types";
import InstanceTarget from "../../types/instance/InstanceTarget";
import dayjs from "dayjs";

export const getComparisonInitialOptions = (instances: InstanceTarget[], hasMetric: boolean): ActivityComparisonOptions => {
    const searchParams = new URLSearchParams(window.location.search);

    const getInstanceName = (id: any) => {
        const instance = instances.find(instance => instance.id === parseInt(id ?? '-1', 10));
        return instance ? instance.name : '';
    };

    const metric = hasMetric ? searchParams.get('metric') : 'waittime';

    const values = {
        aggregate: 'auto',
        compare: searchParams.get('compare') || 'sql',
        metric: metric || '',
        chart: searchParams.get('chart') || 'column',
        topN: parseInt(searchParams.get('topN') || '10', 10) || 10,
        tagName: searchParams.get('tagName') || undefined,
        other: searchParams.get('other') === 'true',
        showSqlId: searchParams.get('showSqlId') === 'true',
        customSqlId: searchParams.get('customId') || '',
        firstInstanceOptions: {
            instanceId: parseInt(searchParams.get('firstInstanceId') ?? '-1', 10) || -1,
            instanceType: undefined,
            periodStart: new Date(searchParams.get('firstInstanceFrom') ?? dayjs().subtract(2, 'hour').toISOString()),
            periodEnd: new Date(searchParams.get('firstInstanceTo') ?? dayjs().subtract(1, 'hour').toISOString()),
            instanceName: getInstanceName(searchParams.get('firstInstanceId')),
            snapshotId: Number(searchParams.get('firstInstanceSnapshotId')) || undefined,
        },
        secondInstanceOptions: {
            instanceId: parseInt(searchParams.get('secondInstanceId') ?? '-1', 10) || -1,
            instanceType: undefined,
            periodStart: new Date(searchParams.get('secondInstanceFrom') ?? dayjs().subtract(1, 'hour').toISOString()),
            periodEnd: new Date(searchParams.get('secondInstanceTo') ?? new Date().toISOString()),
            instanceName: getInstanceName(searchParams.get('secondInstanceId')),
            snapshotId: Number(searchParams.get('secondInstanceSnapshotId')) || undefined,
        },
    };

    return values
};

export const resetComparisonInitialOptions = ( hasMetric: boolean): ActivityComparisonOptions => {

    return {
        aggregate: 'auto',
        compare: 'sql',
        metric: hasMetric ? '' : 'waittime',
        chart: 'column',
        topN: 10,
        tagName: undefined,
        other: false,
        showSqlId: false,
        customSqlId: '',
        firstInstanceOptions: {
            instanceId: -1,
            instanceType: undefined,
            periodStart: new Date(dayjs().subtract(2, 'hour').toISOString()),
            periodEnd: new Date(dayjs().subtract(1, 'hour').toISOString()),
            instanceName: '',
            snapshotId: undefined,
        },
        secondInstanceOptions: {
            instanceId: -1,
            instanceType: undefined,
            periodStart: new Date(dayjs().subtract(1, 'hour').toISOString()),
            periodEnd: new Date(),
            instanceName: '',
            snapshotId: undefined,
        },
    };
};
